import { render, staticRenderFns } from "./TeachersKyTop.vue?vue&type=template&id=49510ccd&scoped=true&"
import script from "./TeachersKyTop.vue?vue&type=script&lang=js&"
export * from "./TeachersKyTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49510ccd",
  null
  
)

export default component.exports